import React from "react";
import { useLoader } from "../../context/LoaderContext";

interface GlobalLoaderProps {
  color?: string;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  color = "bg-secondary",
}) => {
  const { isLoading } = useLoader();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-transparent z-[9999]">
      <div
        className={`w-full h-0.5 ${color} animate-pulse absolute top-0`}
      ></div>
    </div>
  );
};

export default GlobalLoader;
